/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
    Grid,
    Box,
    Checkbox,
    FormControlLabel,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
} from "@mui/material";
import { useState, Fragment } from 'react';
import axios from 'axios';


function RegisterConfirm(props) {

    const {goNextPage, goPreviousPage} = props;
    const [scroll, setScroll] = useState('paper');
    const [checked, setChecked] = useState(false);
    axios.defaults.withCredentials = true; // 세션유지

    const [agree1, setAgree1] = useState(false);
    const openAgree1 = () => {
        setAgree1(true);
    };
    const closeAgree1 = () => {
        setAgree1(false);
    };



    const [agree2, setAgree2] = useState(false);
    const openAgree2 = () => {
        setAgree2(true);
    };
    const closeAgree2 = () => {
        setAgree2(false);
    };

    const [agree3, setAgree3] = useState(false);
    const openAgree3 = () => {
        setAgree3(true);
    };
    const closeAgree3 = () => {
        setAgree3(false);
    };

    const [agree4, setAgree4] = useState(false);
    const openAgree4 = () => {
        setAgree4(true);
    };
    const closeAgree4 = () => {
        setAgree4(false);
    };

    const [agree5, setAgree5] = useState(false);
    const openAgree5 = () => {
        setAgree5(true);
    };
    const closeAgree5 = () => {
        setAgree5(false);
    };
    
    const cbConfirm = () => {
        
    };

    const cbCancel = () => {
        
    };

    const checkControll = (e) => {
        if(cbConfirm) {
            e.target.checked(true);
        } else {
            e.target.checked(false);
        }
    }

    return (
        <Grid
            container
            height="100%"
            direction="column"
            justifyContent="center">
            <Grid
                container
                direction="column"
                flex="1"
                width="100%"
                justifyContent="center"
                alignItems="center">
                <Box sx={{ fontWeight: "bold", fontSize: "20px" }}>
                    서비스 이용약관에 대한 동의(필수)
                </Box>

                <Box css={css `border:1px solid #cccccc; width: 300px; height: 100px;`}>
                    약관내용...
                </Box>

                <Box css={css `margin-top:10px;`}>
                    <Button onClick={goPreviousPage} variant="contained" color="secondary">동의안함</Button><Button onClick={goNextPage} css={css `margin-left:5px;`} variant="contained">약관에 동의합니다.</Button>
                </Box>
            

                
                <br></br>
                
            </Grid>
        </Grid>
    )
}
export default RegisterConfirm;